<template>
    <v-card tile class="no-shadow">
        <v-card-title class="header-id pt-3 mx-0">
            <div class="header-name my-4 ">
                {{$t('contact_informations_detail')}}
            </div>
            <div class="d-flex align-center mt-0">
                <div class="mx-1" v-for="(opportunity, index) in opportunities" :key="index">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on"> 
                                <span v-if="opportunity.tag === 'custom'" class="innerAlert primary bg--text">{{ opportunity.data.name }}</span>
                                <v-img v-else :height="25" :width="25" v-bind="attrs" v-on="on" :src="opportunity.picto.url"></v-img>
                            </div>
                        </template>
                        <span>{{ opportunity.tag === 'custom' ? opportunity.data.name : $t(opportunity.picto.desc) }}</span>
                    </v-tooltip>
                </div>
                <div class="mx-1" v-for="(etiquette, index) in contact.etiquettes" :key="index">
                    <v-chip small outlined color="primary" class="mr-2" >
                        {{etiquette.name }}
                    </v-chip>
                </div>
            </div>
        </v-card-title>
       
        <v-card-text :key="keyId" class="pb-0">
            
            <div class="d-table mt-4">
                <!-- <div class="adress mb-1" v-if='contact.type'>
                    <v-icon  color="primary" small class="mr-2 mt-0" >$contacts_d</v-icon>{{ $t('status') }} : <div class="black--text ml-1">{{ $t(contact.type) }}</div>
                </div>
                <div class="adress mb-1" v-if='contact.pro_part'>
                    <v-icon  color="primary" small class="mr-2 mt-0" >$usertie_d</v-icon>{{ $t('type') }} : <div class="black--text ml-1">{{ $t(contact.pro_part) }}</div>
                </div> -->
                <div class="mb-3">
                    <v-icon color="primary" small class="mr-2 mt-0">$user_d</v-icon>
                    {{contact.firstname}} {{contact.name}} {{contact.company}}
                </div>

                <div v-if="(contact.email && contact.email != '') || (contact.email_pro && contact.email_pro != '')" class="adress mb-3">
                    <v-icon color="primary" small class="mr-2 mt-0">$at_d</v-icon>
                    <div class="ml-1">
                        <div v-if="contact.email && contact.email != ''">
                            <a v-if="!emailBlacklisted" :href="'mailto:' + contact.email">{{ contact.email }}</a>
                            <span v-else>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on" class="error--text blacklistedNumber">
                                            {{ contact.email }}
                                            <v-icon x-small color="error" class="mt-0 ml-2">$ban_l</v-icon>
                                        </span>
                                    </template>
                                    <span>{{ emailBlacklisted }}</span>
                                </v-tooltip>
                            </span>
                        </div>
                        <div v-if="contact.email_pro && contact.email_pro != ''">
                            <a v-if="!emailProBlacklisted" :href="'mailto:' + contact.email_pro">{{ contact.email_pro }}</a>
                            <span v-else>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on" class="error--text blacklistedNumber">
                                            {{ contact.email_pro }}
                                            <v-icon x-small color="error" class="mt-0 ml-2">$ban_l</v-icon>
                                        </span>
                                    </template>
                                    <span>{{ emailProBlacklisted }}</span>
                                </v-tooltip>
                            </span>
                        </div>
                    </div>
                </div>
                <div v-if='contact.phones && contact.phones.length > 0' class="adress mb-3">
                    <v-icon color="primary" small class="mr-2 mt-0">$phone_d</v-icon>
                    <div class="ml-1">
                        <div v-for="(phone, index) in contact.phones" :key="index">
                            <div v-if="!phone.blacklisted">
                                <a :href="'tel:' + phone.number">{{ phoneNumberToClean(phone.number) }}</a>
                            </div>
                            <div v-else>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on" class="error--text blacklistedNumber">
                                            {{ phoneNumberToClean(phone.number) }}
                                        <v-icon x-small color="error" class="mt-0 ml-2">$ban_l</v-icon>
                                        </span>
                                    </template>
                                    <span>{{phone.motif}}</span>
                                </v-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="contact.adress_1 || contact.adress_2 || contact.adress_3 || contact.postal_code || contact.city" class="adress mb-1">
                    <v-icon color="primary" small class="mr-2 mt-0">$mapmarker_d</v-icon>
                    <div v-if="!adressBlacklisted" class="ml-1 black--text">
                        <div v-if="contact.adress_1 != ''">{{contact.adress_1}}</div>
                        <div v-if="contact.adress_2 != ''">{{contact.adress_2}}</div>
                        <div v-if="contact.adress_3 != ''">{{contact.adress_3}}</div>
                        <div v-if="contact.postal_code || contact.city">
                            <span v-if="contact.postal_code">{{ contact.postal_code }} </span>
                            <span v-if="contact.city">{{ contact.city }}</span>
                        </div>
                    </div>
                    <div v-else class="ml-1">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <div
                                v-bind="attrs"
                                v-on="on"
                                class="error--text blacklistedNumber"
                                >
                                <div>
                                    <div v-if="contact.adress_1 != ''">{{contact.adress_1}}</div>
                                    <div v-if="contact.adress_2 != ''">{{contact.adress_2}}</div>
                                    <div v-if="contact.adress_3 != ''">{{contact.adress_3}}</div>
                                    <div v-if="contact.postal_code || contact.city">
                                        <span v-if="contact.postal_code">{{ contact.postal_code }} </span>
                                        <span v-if="contact.city">{{ contact.city }}</span>
                                    </div>
                                    <div v-if="contact.country != ''">{{contact.country}}</div>
                                </div>
                                <v-icon x-small color="error" class="mt-0 ml-2">$ban_l</v-icon>
                                </div>
                            </template>
                            <span>{{contact.adressBlacklisted}}</span>
                        </v-tooltip>
                    </div>
                </div>
                
            </div>
            <div class="mt-1">
                <v-expansion-panels v-model="expansioninfoPanel">
                    <v-expansion-panel class="no-shadow" :key="0">
                        <v-expansion-panel-content class="pa-0 contentContactPanel">
                            <ul>
                                <li v-if="contact.comments && contact.comments != ''" class=" mb-1">
                                    <span class="grey--text">{{$t('comment')}} :</span> {{ contact.comments }}
                                </li>
                                <li v-if="contact.entity_id && contact.entity_id.id && contact.entity_id.label" >
                                    <span class="grey--text">{{$t('sellingPoint')}} : </span>
                                    <router-link v-if="this.$func.hasRight('entity/get') && contact.entity_id.id" :to="{ name: 'EntityDashboard', params: { entity_id: contact.entity_id.id }}">
                                        {{ contact.entity_id.label }}
                                    </router-link>
                                    <span v-else-if="contact.entity_id.label">
                                        {{ contact.entity_id.label }}
                                    </span>
                                    <span v-if="contact.distance_entity">
                                        ({{ Math.round(contact.distance_entity * 10) / 10 }} km)
                                    </span>
                                </li>
                                <li v-if="contact.assignment_user_id && contact.assignment_user_id.id" class=" mb-1">
                                    <span class="grey--text">{{$t('mainSeller')}} : </span>
                                    <router-link v-if="!contact.assignment_user_id.trash && this.$func.hasRight('user/get') && contact.assignment_user_id.id" :to="{ name: 'UserDetail', params: { user_id: contact.assignment_user_id.id }}">
                                        {{ contact.assignment_user_id.firstname.concat(' ', contact.assignment_user_id.name) }}
                                    </router-link>
                                    <v-tooltip v-else-if="contact.assignment_user_id.trash" top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">{{ contact.assignment_user_id.firstname.concat(' ', contact.assignment_user_id.name) }}</span>
                                        </template>
                                        <span>{{ $t('userDeleted') }}</span>
                                    </v-tooltip>
                                    <span v-else>
                                        {{ contact.assignment_user_id.firstname.concat(' ', contact.assignment_user_id.name) }}
                                    </span>
                                </li>
                                <li v-if="contact.language && contact.language != ''" class=" mb-1">
                                    <span class="grey--text">{{$t('lang')}} : </span>{{ $t(contact.language) }}
                                </li>
                                <li v-if="contact.code" class=" mb-1">
                                    <span class="grey--text">{{$t('uniqueCode')}} : </span>{{ contact.code }}
                                </li>
                                <li class=" mb-1">
                                    <span class="grey--text">{{$t('reference')}} : </span> #C{{contact.id}}
                                </li>
                                <li v-for="(custom_property, index) in contact.custom_fields" :key="index" class=" mb-1">
                                    <span class="grey--text">{{ custom_property.to_trad ? $t(custom_property.reference) : custom_property.reference }} : {{ custom_property.value }}</span>
                                </li>
                                <li v-if="contact.total_duration" class=" mb-1">
                                    <span class="grey--text">{{$t('total_duration')}} : </span> {{contact.total_duration}}
                                </li>
                            </ul>
                        </v-expansion-panel-content>          
                    </v-expansion-panel>
                </v-expansion-panels>
                <div class="consentement my-4">
                    <p class="mb-1"><b>{{ $t('consentements') }} : </b></p>
                    <v-tooltip right content-class="white--tooltip" v-for="consent in consents" :key="consent.id">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="square mr-2" v-bind="attrs" v-on="on" :style="'background-color:'+getBackgroundColor(consent)" depressed >
                                <v-icon small :color="getIconColor(consent)">
                                    {{ getIcon(consent.channel) }}
                                </v-icon>
                            </v-btn>
                        </template>
                        <div class="py-2">
                            <p><b>{{$t('consent_'+consent.channel)}}</b></p>
                            <p class="mb-0">{{ $t('status') }} : <span :class="getIconColor(consent)+'--text'">&nbsp;{{ $t(consent.status) }}</span></p>
                            <p class="mb-0" v-if="consent.granted_at">{{ $t('granted_at') }} : <span>&nbsp;{{ parseFullDateToFr(consent.granted_at) }}</span></p>
                            <p class="mb-0" v-if="consent.expires_at">{{ $t('expires_at') }} : <span>&nbsp;{{ parseFullDateToFr(consent.expires_at) }}</span></p>
                            <p class="mb-0" v-if="consent.updated_at">{{ $t('updated_at') }} : <span>&nbsp;{{ parseFullDateToFr(consent.updated_at) }}</span></p>
                            <p class="mb-0" v-if="consent.source">{{ $t('source') }} : <span>&nbsp;{{ $t(consent.source) }}</span></p>
                            <p class="mb-0" v-if="consent.retroplanning_id">{{ $t('source') }} : <span>&nbsp;{{ consent.retroplanning_name }}</span></p>
                        </div>
                    </v-tooltip>
                </div>
                <v-divider></v-divider>
                <div class="mt-2 mb-0">
                    <a @click="openCloseExpansionPanel" v-if="expansioninfoPanel == null">
                        <span class="mr-2 ">{{$t('seemore')}}</span>
                        <v-icon  small>$down_l</v-icon>
                    </a>
                    <a @click="openCloseExpansionPanel" v-else>
                        <span class="mr-2 ">{{$t('seeless')}}</span>
                        <v-icon  small>$up_l</v-icon>
                    </a>
                </div>
            </div>
        </v-card-text>
        <!-- <v-card-actions>
            <v-btn small v-if="this.$func.hasRight('contact/update')" class=" editButton ml-2" color="primary" depressed @click="$emit('edit')">
                    {{$t('modify')}} <v-icon small class="ml-2">$next</v-icon>
                </v-btn>
             <v-btn small v-if="this.$func.hasRight('contact/update') && (!packId || packId != 4)" :disabled="blacklistItems.length ? false : true" class=" editButton ml-2 white--text" color="black" depressed @click="blacklist">
                <v-icon small class="mr-2">$ban_d</v-icon> {{$t('blacklist')}} 
            </v-btn> 
        </v-card-actions> -->
    </v-card>
</template>
<script>
import GenericDataService from '@/services/GenericDataService'
import dateManipulation from '@/mixins/dateManipulation'

export default {
    name:"idComponent",
    props:['contact', 'blacklistItems'],
    mixins: [dateManipulation],
    data() {
        return {
            publicPath: process.env.BASE_URL,
            opportunities: {},
            blacklists: [],
            keyId:0,
            expansioninfoPanel: null,
            consents: []
        }
    },
    mounted() {
        if(this.$route.params.contact_id ){
            GenericDataService.getData('/contact/'+this.$route.params.contact_id+'/getAlerts').then((response) => {
                this.opportunities = response.data.data
            })
        }
       
    },
    watch: {
        contact(val){
            if(val && val.id){
                GenericDataService.getData('/contact/'+val.id+'/getAlerts').then((response) => {
                    this.opportunities = response.data.data
                })
                GenericDataService.getData('/optin/getContactConsents?contactId='+val.id).then((response) => {
                    this.consents = response.data.data
                })
            }
        }
    },
    methods: {
        openCloseExpansionPanel(){
            if(this.expansioninfoPanel == 0){
                this.expansioninfoPanel = null
            }else{
                this.expansioninfoPanel = 0
            }
        },
        getIcon(channel){
            switch(channel){
                case 'email':
                    return '$at_d'
                case 'mobile_message':
                    return '$mobile_d'
                case 'phone':
                    return '$phone_d'
                case 'mailing':
                    return '$envelope_d'
                case 'ads':
                    return '$rectanglead_d'
            }
        },
        getIconColor(consent){
            switch(consent.status){
                case 'granted':
                    return 'success'
                case 'denied':
                case 'withdrawn':
                case 'expired':
                    return 'error'
                case 'soon_expired':
                    return 'warning'
                case 'unknown':
                    return 'grey'
                case 'blacklisted':
                    return 'black'
            }
        },
        getBackgroundColor(consent){
            switch(consent.status){
                case 'granted':
                    return 'rgba(91, 184, 93, 0.3)'
                case 'denied':
                case 'withdrawn':
                case 'expired':
                    return 'rgba(217, 84, 79, 0.3)'
                case 'soon_expired':
                    return 'rgba(239, 173, 77, 0.3)'
                case 'blacklisted':
                    return 'rgba(0, 0, 0, 0.3)'
            }
        }
    },
    computed: {
        packId(){
            if(this.$store.state.auth.currentUser.accountParameters.packId)
                return this.$store.state.auth.currentUser.accountParameters.packId
            else 
                return false
        },
        adressBlacklisted(){
            return this.blacklists.find(bl => bl.value === this.contact.id) ? this.blacklists.find(bl => bl.value === this.contact.id).motif : false
        },
        emailBlacklisted(){
            return (this.contact.email && this.blacklists.find(bl => bl.value === this.contact.email)) ? this.blacklists.find(bl => bl.value === this.contact.email).motif : false
        },
        emailProBlacklisted(){
            return (this.contact.email_pro && this.blacklists.find(bl => bl.value === this.contact.email_pro)) ? this.blacklists.find(bl => bl.value === this.contact.email_pro).motif : false
        },
    }
}
</script>
<style lang="scss">
    .contentContactPanel {
        .v-expansion-panel-content__wrap {
            padding:0 !important;
        }
        ul {
            list-style:none;
            li {
                position:relative;
                .listPoint {
                    position:absolute; 
                    left:-23px; 
                    top:3px;
                }
            }
        }
    }
    
    .header-id {
        //font-size:24px;
        display:flex;
        //justify-content: space-between;
        //margin-left: 30px;
        .header-name {
            width:100%;
            font-size:1.25rem;
            .v-image {
                margin-right:10px;
            }
        }
    }
    .v-card__subtitle {
        margin-left: 30px;
        display:flex;
        align-items:center;
        line-height: 1;
        @media (-webkit-device-pixel-ratio: 1.25) {
            margin-left:15px;
        }
    }
    .adress {
        display: flex;
        .v-icon {
            margin-top: 3px;
        }
    }
    .v-rating {
        height:18px;
        margin-left:20px;
        display:flex;
        align-items: center;
        button {
            margin-right:5px;
        }
    }
    .blacklistedNumber {
        display:flex;
        align-items: center;
        justify-content: flex-start;
    }
    .block {
        width:100%;
        td {
            width:50%;
        }
    }
    table {
        width:100%;
        margin-bottom:10px;
        &:last-child {
            margin-bottom:0px;
        }
    }
    .innerAlert {
        padding: 0px 4px;
        border-radius: 5px;
    }
</style>
